import { j as O } from "./jsx-runtime-3tyXYecC.mjs";
import { Component as b } from "react";
import { n as s } from "./compact-CN4wKJco.mjs";
import { f as a } from "./index-LyFokDcn.mjs";
import { B } from "./button-CUHBhgeQ.mjs";
import { T as F } from "./text-button-yPCa43NP.mjs";
import { I as v } from "./icon-button-BxDvkq_l.mjs";
import { F as _ } from "./floating-icon-button-CHJsoxe2.mjs";
import { I as N } from "./icon-v2-DGtVEk7e.mjs";
import { M as j } from "./menu-63UgiRJf.mjs";
var i = /* @__PURE__ */ ((e) => (e.BUTTON = "button", e.ICON = "icon", e.TEXT = "text", e))(i || {});
const D = "fab-dropdown-caret-9x5";
function E(e) {
  switch (e) {
    case "extra-small":
      return 12;
    default:
      return 16;
  }
}
function M(e, t, n = !0) {
  const o = { ...e };
  if (n) {
    const r = A(e, t), c = a.ifFeature(
      "encore",
      /* @__PURE__ */ O.jsx(N, { name: "caret-down-solid", size: E(o.size) }),
      D
    );
    o[r] = c;
  }
  return o;
}
function A(e, t) {
  return U(e, t) ? a.ifFeature("encore", "endIcon", "iconAfter") : "icon";
}
function U(e = {}, t) {
  return !!(e.icon || e.iconBefore || e.text || t);
}
function T(e = 0) {
  return e == 100;
}
function z(e) {
  switch (e) {
    case i.BUTTON:
      return B;
    case i.ICON:
      return a.ifFeature("encore", v, _);
    case i.TEXT:
      return F;
    default:
      return B;
  }
}
const C = class C extends b {
  constructor() {
    super(...arguments), this._handleSelect = (t, n) => {
      const { onSelect: o = s } = this.props, r = o(t.value, { item: t, parentItem: n });
      return Promise.resolve(r);
    }, this._renderToggle = ({ isFocused: t }, n) => {
      const {
        biId: o,
        ButtonProps: r,
        buttonSettings: c = {},
        children: l,
        isDisabled: d,
        showCaret: h,
        type: p = i.BUTTON,
        width: m
      } = this.props, f = z(p), u = {};
      return o && (u["data-bi-id"] = `${o}-dropdown-toggle`), /* @__PURE__ */ O.jsx(
        f,
        {
          ...M(a.ifFeature("encore", r, c), l, h),
          ...u,
          ...n,
          ...a.ifFeature("encore", {}, r),
          isDisabled: d,
          isFocused: t,
          tabindex: "-1",
          type: "button",
          width: m,
          children: l
        }
      );
    }, this.state = {
      isOpen: !1
    };
  }
  _handleClose() {
    const { onClose: t = s } = this.props, n = t();
    return Promise.resolve(n).then(() => {
      this.setState({ isOpen: !1 });
    });
  }
  _handleOpen() {
    const { onOpen: t = s } = this.props, n = t();
    return Promise.resolve(n).then(() => {
      this.setState({ isOpen: !0 });
    });
  }
  render() {
    const {
      biId: t,
      ButtonProps: n,
      buttonSettings: o,
      canSelectMultiple: r,
      isDisabled: c,
      items: l,
      placement: d,
      renderOptionContent: h,
      onSelect: p,
      onDeselect: m,
      showSearch: f,
      searchPlaceholder: u,
      searchThreshold: S,
      selectedItems: x,
      width: P,
      menuWidth: w
    } = this.props, { isOpen: g } = this.state;
    return /* @__PURE__ */ O.jsx(
      j,
      {
        biId: t,
        canQuickSelect: g,
        canSelectMultiple: r,
        "data-fabric-component": "Dropdown",
        isDisabled: c,
        isFullWidth: T(n == null ? void 0 : n.width) || T(o == null ? void 0 : o.width) || T(P),
        isOpen: g,
        items: l,
        onClose: () => this._handleClose(),
        onDeselect: r ? m : s,
        onOpen: () => this._handleOpen(),
        onSelect: r ? p : this._handleSelect,
        placement: d,
        renderOptionContent: h,
        renderToggle: this._renderToggle,
        searchPlaceholder: u,
        searchThreshold: S,
        selectedItems: r ? x : void 0,
        showSearch: f,
        width: w
      }
    );
  }
};
C.defaultProps = {
  canSelectMultiple: !1,
  isDisabled: !1,
  onClose: s,
  onOpen: s,
  onSelect: s,
  onDeselect: s,
  placement: {
    align: "end",
    side: "bottom"
  },
  showCaret: !0,
  showSearch: "never",
  type: i.BUTTON
};
let I = C;
export {
  I as D,
  i as a
};
//# sourceMappingURL=dropdown-Do4wRJvN.mjs.map
